// page : '/obsrec/kansatsukiroku/:koujibangou/:key'
// base lib
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import * as moment from 'moment';
// import ReactToPrint from 'react-to-print'; // 印刷別画面機能は保留
// material-ui
import { Typography, Paper, Button } from '@material-ui/core';
import CloudUpload from '@material-ui/icons/CloudUpload';
import DeleteForever from '@material-ui/icons/DeleteForever';
// import Print from '@material-ui/icons/Print';  // 印刷別画面機能は保留
// 画像切り取りライブラリ
import 'cropperjs/dist/cropper.css';
// model
import { SiteInfo } from '../../models/SiteInfo';
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';
import { InferenceResultObsrec } from '../../models/InferenceResultObsrec';

// parts
// import { InferenceResultObsrecView } from '../parts/InferenceResultObsrecView';  // 総合評価表の表示は保留
import { CloseBackButton } from '../parts/CloseBackButton'; // 戻るボタン
import KansatsuKirokuEdit from '../parts/KansatsuKirokuEdit'; // 観察記録のテキスト入力エリア
// import KansatsuKirokuScoreEdit from '../parts/KansatsuKirokuScoreEdit'; // 観察記録のスコア入力エリア
import KansatsuKirokuScoreEditForObsrec from '../parts/KansatsuKirokuScoreEditForObsrec'; // 観察記録のスコア入力エリア
// redux state
import { IAppState } from '../../redux/modules';
import { SiteInfoListObsrecState } from '../../redux/modules/siteInfoListObsrec';
import { KansatsuKirokuObsrecState } from '../../redux/modules/kansatsuKirokuObsrec';
// redux operations
import { kansatsuKirokuObsrecOperations } from '../../redux/modules';
// page
// import { PrintKansatsuKirokuObsrec } from './PrintKansatsuKirokuObsrec';

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px',
  },
  img: {
    position: 'sticky' as 'sticky',
    zIndex: 2,
    padding: '20px',
    marginBottom: '20px',
    width: 'auto',
    top: '0px',
    left: '30px',
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListObsrecState;
  history: H.History;
  kansatsuKirokuObsrec: KansatsuKirokuObsrecState;
  clear: () => void;
  reset: () => any;
  getRecord: ({ koujiBangou, key, completeHandler }
    : { koujiBangou: string, key: string, completeHandler: () => any }) => any;
  postRecord: (record: KansatsuKirokuObsrec, completeHandler: () => any) => any;
}

interface OwnState {
  // 工事現場の情報
  site: SiteInfo;

  // 細分化 行サイズ
  lineNum: number;
  // 細分化 列サイズ
  columnNum: number;
  // 観察項目名
  observationNames: string[];
  // 観察項目_説明
  observationDescriptions: string[];
  // 総合評価初期値用
  defaultInferenceResultObsrec: InferenceResultObsrec[];
};

class EditKansatsuKirokuObsrecObsrecPage extends React.Component<OwnProps, OwnState>{
  private kansatsuKirokuObsrecEditElement: KansatsuKirokuEdit;
  private kansatsuKirokuObsrecScoreEditElement: KansatsuKirokuScoreEditForObsrec;
  private previewCanvasElement;
  // 印刷対象Elementへの参照
  // private printTargetRef;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: new SiteInfo(),
      lineNum: 0,
      columnNum: 0,
      observationNames: [],
      observationDescriptions: [],
      defaultInferenceResultObsrec: [],
    };
  }

  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/obsrec/sitelist');
      return;
    }
    const lineNumInfo = siteInfo.lineNum;
    const columnNumInfo = siteInfo.columnNum;
    const observationNamesInfo = siteInfo.observationNames;
    const observationDescriptionsInfo = siteInfo.observationDescriptions;
    const obsrecWeightsInfo = siteInfo.obsrecWeights;
    const tmpdefaultInferenceResultObsrec : InferenceResultObsrec[] = [];
    observationNamesInfo.map((observationName) => {
      obsrecWeightsInfo.map((obsrecWeight) => {
        if (obsrecWeight.obsrecName === observationName){
          tmpdefaultInferenceResultObsrec.push(
            {
              'observation': obsrecWeight.obsrecKey,
              'observation_name': observationName,
              'weight': obsrecWeight.weight,
              'overlay_img_bucket': '',
              'overlay_img_key' : '',
              'overlay_img_presigned_url': '',
              'result_score' : {
                'left': {
                  'mode': '',
                  'mean': ''
                },
                'top': {
                  'mode': '',
                  'mean': ''
                },
                'right': {
                  'mode': '',
                  'mean': ''
                }
              }
            }
          )
        }
      })
    })

    this.setState({
      site: siteInfo,
      lineNum: lineNumInfo,
      columnNum: columnNumInfo,
      observationNames: observationNamesInfo,
      observationDescriptions: observationDescriptionsInfo,
      defaultInferenceResultObsrec : tmpdefaultInferenceResultObsrec,
    });
    this.props.getRecord({
      koujiBangou,
      key: this.props.match.params.key,
      completeHandler: () => {
        this.drawImage();
        // @ts-ignore
      }
    });

  }
  componentWillUnmount() {
    this.props.reset();
  }

  /**
   * データを登録する
   */
  register() {
    // 登録するレコード
    const record = { ...this.props.kansatsuKirokuObsrec.item };
    const kansatsuKirokuObsrecEditData = this.kansatsuKirokuObsrecEditElement.get();
    record.kansatsuDate = kansatsuKirokuObsrecEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuObsrecEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuObsrecEditData.danmenNumber;
    record.kyori = kansatsuKirokuObsrecEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuObsrecEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuObsrecEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuObsrecEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuObsrecEditData.kyoriMemo;
    // record.inferenceResultObsrecJsonStr = JSON.stringify(record.inferenceResultObsrec);
    // record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(record.inferenceAdditionalResultObsrec);
    record.freeInputs = kansatsuKirokuObsrecEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuObsrecEditData.freeInputs);
    // このページでは修正のみなのでlastModifiedAtのみ設定
    record.lastModifiedAt = moment().format();

    const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get()
    record.observationsScores = kansatsuKirokuObsrecScoreEditElementData.observationsScores;
    record.observationsScoresJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.observationsScores);
    record.inferenceResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.resultHuman);
    record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.additionalResultHuman);
    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }
  /**
   * データを削除する
   * ここでの削除は論理削除なので、deletedAtに日時を指定してpostする
   */
  delete() {
    if (!confirm('観察記録を削除しますか？')) {
      return;
    }
    // 削除するレコード
    const record = { ...this.props.kansatsuKirokuObsrec.item };

    const kansatsuKirokuObsrecEditData = this.kansatsuKirokuObsrecEditElement.get();
    record.kansatsuDate = kansatsuKirokuObsrecEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuObsrecEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuObsrecEditData.danmenNumber;
    record.kyori = kansatsuKirokuObsrecEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuObsrecEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuObsrecEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuObsrecEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuObsrecEditData.kyoriMemo;
    // record.inferenceResultObsrecJsonStr = JSON.stringify(record.inferenceResultObsrec);
    // record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(record.inferenceAdditionalResultObsrec);
    record.freeInputs = kansatsuKirokuObsrecEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuObsrecEditData.freeInputs);

    const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get()
    record.observationsScores = kansatsuKirokuObsrecScoreEditElementData.observationsScores;
    record.observationsScoresJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.observationsScores);
    record.inferenceResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.resultHuman);
    record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.additionalResultHuman);

    // 削除時刻のみ設定
    record.deletedAt = moment().format();

    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }

  drawImage() {
    const img = new Image();
    // const img = document.getElementById('croppedImage');

    img.src = this.props.kansatsuKirokuObsrec.item.croppedImageSignedUrl;
    img.onload = () => {
      canvasContext.strokeStyle = 'white';
      canvasContext.drawImage(img,
        0, 0, this.state.site.cropImageWidth, this.state.site.cropImageHeight,
        0, 0, this.state.site.cropImageWidth, this.state.site.cropImageHeight);
      // 横線の描画
      for (let i = 1; i < lineNum; i++) {
        const startY = i / lineNum * this.state.site.cropImageHeight;
        const startX = 0
        const endY = startY
        const endX = this.state.site.cropImageWidth
        canvasContext.beginPath();
        canvasContext.moveTo(startX, startY);
        canvasContext.lineTo(endX, endY);
        canvasContext.stroke();
      }
      // 縦線の描画
      for (let i = 1; i < columnNum; i++) {
        const startY = 0;
        const startX = i / columnNum * this.state.site.cropImageWidth;
        const endY = this.state.site.cropImageHeight;
        const endX = startX
        canvasContext.beginPath();
        canvasContext.moveTo(startX, startY);
        canvasContext.lineTo(endX, endY);
        canvasContext.stroke();
      }

      canvasContext.textAlign = "center";
      canvasContext.font = "bold 30px 'sans-serif'";
      let x = 0;
      let y = 0;
      let positionStr = ''
      for (let iLine = 0; iLine < lineNum; iLine++) {
        for (let iCol = 0; iCol < columnNum; iCol++) {
          positionStr = (iLine + 1).toString() + '-' + (iCol + 1).toString();
          x = (0.5 + iCol) * this.state.site.cropImageWidth / columnNum;
          y = (0.5 + iLine) * this.state.site.cropImageHeight / lineNum;

          canvasContext.fillStyle = '#FFFFFF';
          canvasContext.globalAlpha = 1;
          canvasContext.fillText(positionStr, x, y);

          canvasContext.strokeStyle = "#000000";
          canvasContext.globalAlpha = 1;
          canvasContext.strokeText(positionStr, x, y);

        }
      }
    };
    const canvasContext = this.previewCanvasElement.getContext('2d');

    this.previewCanvasElement.width = this.state.site.cropImageWidth;
    this.previewCanvasElement.height = this.state.site.cropImageHeight;

    const lineNum = this.state.lineNum;
    const columnNum = this.state.columnNum;
  }

  toggleByDevice() {
    // if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPad') > 0) {
    //   return {
    //     display: 'block',
    //     width: this.state.site.cropImageWidth,
    //     height: this.state.site.cropImageHeight,
    //     // position: '-webkit-sticky' as '-webkit-sticky', /* ios */
    //     position: 'sticky' as 'sticky',
    //     zIndex: 2,
    //     padding: '20px',
    //     marginBottom: '20px',
    //     top: '0px',
    //     left: '30px',
    //   }
    // }
    return {
      display: 'block',
      width: this.state.site.cropImageWidth,
      height: this.state.site.cropImageHeight,
      position: 'sticky' as 'sticky',
      zIndex: 2,
      padding: '20px',
      marginBottom: '20px',
      top: '0px',
      left: '30px',
    }
  }

  render() {
    const site = this.state.site || new SiteInfo();
    const isDeleted = this.props.kansatsuKirokuObsrec.item.deletedAt ? true : false;

    return (
      <div>
        <Paper style={{ padding: '10px' }}>
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {site.koujiBangou} : {site.name}
          </Typography>
          <div className="command-area">
            <div className="command-area-left">
              <Typography variant="h6">観察記録 {isDeleted ? '　（削除済み） ' : ''}</Typography>
            </div>
            <div className="command-area-right">
              <Typography variant="body2" style={{ color: 'rgba(0,0,0,0.54)', textAlign: 'right' }}>
                作成 {this.props.kansatsuKirokuObsrec.item.createdAt ? moment(this.props.kansatsuKirokuObsrec.item.createdAt).format('MM/DD HH:mm') : '-'}<br />
                更新 {this.props.kansatsuKirokuObsrec.item.lastModifiedAt ? moment(this.props.kansatsuKirokuObsrec.item.lastModifiedAt).format('MM/DD HH:mm') : '-'}
              </Typography>
            </div>
          </div>

          <Paper
            style={styles.contentBase}
          >
            <KansatsuKirokuEdit
              disabled={isDeleted}
              data={this.props.kansatsuKirokuObsrec.item}
              ref={(r) => {
                if (r) {
                  this.kansatsuKirokuObsrecEditElement = r;
                }
              }}
            />
          </Paper>

          <Paper
            style={styles.contentBase}
          >
            <Typography variant="h6">撮影画像</Typography>
            {
              (this.props.kansatsuKirokuObsrec.item.croppedImageSignedUrl)
                ? <canvas
                  id='croppedImageCanvas'
                  style={this.toggleByDevice()}
                  ref={(r) => {
                    if (r) {
                      this.previewCanvasElement = r;
                    }
                  }}
                />
                : <div>撮影画像なし</div>
            }
            <div style={{
              width: this.state.site.cropImageWidth,
              padding: '20px',
              marginBottom: '20px',
            }}>
              {/* <KansatsuKirokuScoreEdit
                disabled={isDeleted}
                // data={this.props.kansatsuKirokuObsrec.item}
                data={this.props.kansatsuKirokuObsrec.item.observationsScores}
                lineNum={this.state.lineNum}
                columnNum={this.state.columnNum}
                observationNames={this.state.observationNames}
                observationDescriptions={this.state.observationDescriptions}
                ref={(r) => {
                  if (r) {
                    this.kansatsuKirokuObsrecScoreEditElement = r;
                  }
                }}
              /> */}
              <KansatsuKirokuScoreEditForObsrec
                disabled={isDeleted}
                // data={this.props.kansatsuKirokuObsrec.item}
                data={this.props.kansatsuKirokuObsrec.item.observationsScores}
                lineNum={this.state.lineNum}
                columnNum={this.state.columnNum}
                observationNames={this.state.observationNames}
                observationDescriptions={this.state.observationDescriptions}
                // result={this.props.kansatsuKirokuObsrec.item.inferenceResultObsrec}
                result={this.state.defaultInferenceResultObsrec}
                cropImageWidth={site.cropImageWidth}
                // 評価値確定がステップルールの場合に必要な要素
                targetStepRuleObservationNames={site.targetStepRuleObservationNames}
                // 評価値確定が最頻値ルールの場合に必要な要素
                targetModeRuleObservationNames={site.targetModeRuleObservationNames}
                // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
                targetMeanDeduplicationRuleObservationNames={site.targetMeanDeduplicationRuleObservationNames}
                // 評価値確定が平均<一般>ルールの場合に必要な要素
                targetMeanGeneralRuleObservationNames={site.targetMeanGeneralRuleObservationNames}
                topBadsideSize={site.topBadsideSize}
                leftBadsideSize={site.leftBadsideSize}
                rightBadsideSize={site.rightBadsideSize}

                ref={(r) => {
                  if (r) {
                    this.kansatsuKirokuObsrecScoreEditElement = r;
                  }
                }}
              />
            </div>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => this.register()}
              disabled={isDeleted}
            >
              <CloudUpload style={{ marginRight: '5px' }} />
              観察記録を保存
            </Button>
          </Paper>
          {/* <div
          style={{ paddingLeft: '20px' }}
        >
          <ReactToPrint
            // @ts-ignore
            trigger={() => {
              return (
                <Button
                  variant="contained"
                >
                  <Print style={{ marginRight: '5px'}}/>
                  印刷
                </Button>
              );
            }}
            content={() => this.printTargetRef}
            // 印刷のタイトル、環境によってはPDF保存時のファイル名のデフォルトになる
            documentTitle="観察簿"
          />
        </div> */}
          <div className="command-area">
            <div className="command-area-left">
              <CloseBackButton history={this.props.history} />
            </div>
            <div className="command-area-right">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => this.delete()}
                disabled={isDeleted}
              >
                <DeleteForever style={{ marginRight: '5px' }} />
                観察記録を削除
              </Button>
            </div>
          </div>
        </Paper>
        {/* データ印刷領域 */}
        <div
          style={{
            display: 'none'
          }}
        >
          {/* <div  ref={(el) => this.printTargetRef = el}>
          <PrintKansatsuKirokuObsrec siteInfo={site} kansatsuKiroku={this.props.kansatsuKirokuObsrec.item} />
        </div> */}
        </div>

      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuObsrecOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, completeHandler) => {
      kansatsuKirokuObsrecOperations.post(record)(dispatch)
        .then(() => completeHandler());
    },
    reset: () => {
      kansatsuKirokuObsrecOperations.resetRecord()(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoListObsrec,
    kansatsuKirokuObsrec: appState.kansatsuKirokuObsrec
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditKansatsuKirokuObsrecObsrecPage);



// WEBPACK FOOTER //
// ./src/components/obsrec/EditKansatsuKirokuObsrecPage.tsx